import React from 'react';
import {Tooltip} from 'antd';
import './ImagePreviewTooltip.css';

const ImagePreviewTooltip = ({
  children,
  ...rest
}) => {

  return (
    <Tooltip
      classNames={{root: 'image-preview-tooltip-overlay'}}
      arrow={false}
      placement='left'
      {...rest}
    >
      {children}
    </Tooltip>
  );
}

export default ImagePreviewTooltip;
